const sleep = (time = 1000): Promise<void> =>
    new Promise((resolve) => {
        setTimeout(resolve, time);
    });

export default sleep;
